import { parse } from '@tock/query-string';
import { useHistory, useLocation } from 'react-router-dom';

import { useActions } from '@tock/shared/utils/connect';
import { useMountEffect } from '@tock/hooks';

const AccountActivateRoute = () => {
  const history = useHistory();
  const location = useLocation();
  const { actions } = useActions();

  useMountEffect(() => {
    if (BROWSER) {
      const { search } = location;
      const query = parse(search);

      if (!query.token || !query.email) {
        actions.toast.showError('Invalid activation link');
        handleContinue();
      }
      actions.app
        .loginWithAccountActivationToken(query.token)
        .then(() => actions.app.activateAccount(query.token))
        .then(() => actions.app.fetchPatronProfile())
        .then(handleContinue)
        .catch(handleContinue);
    }
  });

  const handleContinue = () => {
    history.push(`/profile`);
  };

  return (
    <div className="AccountActivateRoute">
      <div className="AccountActivateRoute-message">Activating your account...</div>
    </div>
  );
};

export default AccountActivateRoute;
